import { render, staticRenderFns } from "./DraggableElementsMenu.vue?vue&type=template&id=7a83c6c9&scoped=true&"
import script from "./DraggableElementsMenu.vue?vue&type=script&lang=js&"
export * from "./DraggableElementsMenu.vue?vue&type=script&lang=js&"
import style0 from "./DraggableElementsMenu.vue?vue&type=style&index=0&id=7a83c6c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a83c6c9",
  null
  
)

export default component.exports